/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, ButtonBase, Collapse, Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_blanco.svg'
import {CreditCard, KeyboardArrowDownOutlined} from '@mui/icons-material'
import {SECCIONES} from "../../Constantes";
import hoja from '../../Recursos/hoja.svg'
import {useNavigate} from "react-router-dom";
import {theme} from "../../Tema";
import {useEffect, useRef, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";


const BarraPc = ({esRoja}) => {
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const [adicionales, setAdicionales] = useState([])
    const ref = useRef()

    useEffect(() => {

        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'adicionales', wheres: w}).then((dox) => {
            setAdicionales(dox.data)
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: 'linear-gradient(180deg, #000 7.23%, rgba(0, 0, 0, 0.00) 100%)',
                backgroundColor: esRoja ? theme.palette.primary.main : '#00000000',
                mb: -16,
            }}

        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 4}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <img src={logo} width={260} height={'auto'} alt={'Logo'} onClick={() => navigate('/Home')}
                         style={{cursor: 'pointer'}}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-end', mr: -6, ml: 6}}>
                    <Grid
                        container
                        justifyContent={'space-between'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {SECCIONES.map((it) => {
                            return (
                                <Typography
                                    onClick={() => navigate('/' + it)}
                                    sx={{
                                        color: '#fff',
                                        transition: 'all .1s ease-in-out',
                                        fontWeight: 500,
                                        fontSize: 16,
                                        borderBottom: 1,
                                        borderColor: '#ffffff00',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            borderColor: '#fff'
                                        }
                                    }}
                                >
                                    {it}
                                </Typography>
                            )
                        })
                        }

                        <Typography
                            onClick={() => navigate('/Sostenibilidad')}
                            sx={{
                                color: '#fff',
                                transition: 'all .1s ease-in-out',
                                fontWeight: 500,
                                fontSize: 16,
                                borderBottom: 1,
                                borderColor: '#ffffff00',
                                cursor: 'pointer',
                                '&:hover': {
                                    borderColor: '#fff'
                                }
                            }}
                        >
                            <span><img src={hoja} width={20} height={'auto'} style={{marginBottom: -4, marginTop: 2}}/></span> Sostenibilidad

                        </Typography>

                        <ButtonBase>
                            <Typography
                                onClick={() => setOpen(true)}
                                ref={ref}
                                sx={{
                                    color: '#fff',
                                    transition: 'all .1s ease-in-out',
                                    fontWeight: 500,
                                    fontSize: 16,
                                    borderBottom: 1,
                                    borderColor: '#ffffff00',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#fff'
                                    }
                                }}
                            >
                                Mas
                                <span><KeyboardArrowDownOutlined sx={{mt: 0, mb: -0.8, pl: 1}}/></span>


                            </Typography>
                        </ButtonBase>

                        <Collapse in={open} sx={{width: 250, position: 'absolute', ml: 40, mt: 8}}>
                            <Grid
                                onMouseLeave={() => setOpen(false)}
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{width: 100, backgroundColor: '#fff', p: 2, boxShadow: 4}}
                            >

                                {adicionales.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 1}}>
                                            <Typography
                                                onClick={() => {
                                                    navigate('/Adicionales/' + it.id)
                                                    setOpen(false)

                                                }
                                                }
                                                sx={{
                                                    transition: 'all .1s ease-in-out',
                                                    fontSize: 14,
                                                    borderBottom: 1,
                                                    borderColor: '#ffffff00',
                                                    cursor: 'pointer',
                                                    color: '#000',
                                                    '&:hover': {
                                                        borderColor: '#000',
                                                    },
                                                    lineHeight: 1.2

                                                }}
                                            >{it.nombre}</Typography>
                                        </Grid>
                                    )
                                })}


                            </Grid>

                        </Collapse>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        disabled
                        onClick={() => navigate('/Pagos')}
                        startIcon={<CreditCard/>}>Pagos</Button>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default BarraPc